import React, { memo } from 'react';
import Search from '@atlaskit/icon/core/search';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
var searchPanelStyles = xcss({
  paddingTop: 'space.025',
  paddingBottom: 'space.150',
  paddingLeft: 'space.300',
  paddingRight: 'space.300'
});
var searchIconStyles = xcss({
  paddingTop: 'space.050',
  paddingBottom: 'space.0',
  paddingLeft: 'space.100',
  paddingRight: 'space.0'
});
export var SearchPanel = /*#__PURE__*/memo(function (_ref) {
  var onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [searchPanelStyles]
  }, /*#__PURE__*/React.createElement(Textfield, {
    name: "search",
    id: "search-textfield",
    placeholder: "Find or describe...",
    elemBeforeInput: /*#__PURE__*/React.createElement(Box, {
      xcss: searchIconStyles
    }, /*#__PURE__*/React.createElement(Search, {
      label: "search",
      color: "var(--ds-text-subtlest, #626F86)"
    })),
    onChange: onChange
  }));
});